<div class="page-container">
  <app-toolbar [title]="'COMMON.UPLOAD_MEETING' | translate"></app-toolbar>
  <div class="page">
    <div class="step-progress-container">
      <app-step-progress [steps]="stepLabels" [currentStep]="1" [disabled]="true"></app-step-progress>
    </div>

    <div class="setup-content">
      @if (data !== null) {
        <div class="step-card">
          <div class="step-header">
            <h3>{{ 'MEETING_SETUP.CREATE_MEETING.STEP_TITLE' | translate }}</h3>
            <p>{{ 'MEETING_SETUP.UPLOAD_MEETING.DESCRIPTION' | translate }}</p>
          </div>

          <div class="meeting-details-form">
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>{{ 'MEETING_SETUP.MEETING_DETAILS.MEETING_NAME' | translate }}</mat-label>
              <input matInput [(ngModel)]="data.name" required />
            </mat-form-field>

            <app-datetime-picker [(ngModel)]="data.date" [required]="true" translationKey="MEETING_SETUP.MEETING_DETAILS.MEETING_DATE"></app-datetime-picker>

            @if (teamUsersWithoutCurrentUser$ | async; as result) {
              @if (result.isSuccess) {
                <app-selection
                  labelKey="COMMON.ADDITIONAL_MEETING_OWNERS"
                  idField="id"
                  nameField="fullName"
                  [options]="addFullNameToUserList(result.data!)"
                  (selectionChange)="onUserSelectionChange($event)"
                ></app-selection>
                <div class="disclaimer-box">
                  <mat-icon class="disclaimer-icon">info</mat-icon>
                  {{ 'UPLOAD_MEETING.DISCLAIMER' | translate }}
                </div>
              }
            }
          </div>

          <div class="step-actions">
            @if (uploadMeetingMutation.result$ | async; as result) {
              @if (result.isPending) {
                <mat-spinner diameter="20"></mat-spinner>
              } @else {
                <button mat-flat-button color="primary" (click)="onCreateMeetingClicked()" [disabled]="isCreateButtonDisabled">
                  {{ 'MEETING_SETUP.MEETING_DETAILS.CREATE_MEETING' | translate }}
                </button>
              }
            }
          </div>
        </div>
      }
    </div>
  </div>
</div>
